import { Controller } from "@hotwired/stimulus"
import { Turbo } from "@hotwired/turbo-rails"

// Verrou freemium (Dashboard::LockedValueComponent, Dashboard::LockedChartComponent,
// #2501, #2559) : le tooltip s'ouvre au survol et au focus clavier (CSS pur), Échap le
// referme en retirant le focus.
//
// Le clic mène au paywall (`url`). Un verrou vit souvent dans un lien (ligne du tableau,
// carte Top Signal) qui mène à la fiche match, désormais ouverte aux non-payants : le
// clic est donc capturé ici, sans quoi il ouvrirait la fiche au lieu du paywall.
export default class extends Controller {
  static values = { url: String }

  close() {
    this.element.blur()
  }

  open(event) {
    if (!this.urlValue) return

    event.preventDefault()
    event.stopPropagation()
    Turbo.visit(this.urlValue)
  }
}
